import loaderSvgDefinition from '../svg-definitions/popup-loader-svg-definition.html';

class Loader {

	render() {
		return `
            ${loaderSvgDefinition}
            <div class="loader--chbox__spinner">
                <svg>
                    <use href="#icon-compass2"></use>
                </svg>
            </div>
        `;
	}
}

export default Loader;